module.exports = "precision mediump float;\n\nvarying vec2 vTextureCoord;\nuniform sampler2D texture;\n\n\nuniform vec4 color;\n\nvoid main (void)\n{\n   \n   vec4 col = texture2D(texture, vTextureCoord);\n   \n   // severity is based off of xy.\n   // float smoothStepx = smoothstep( 0.0, 1.0, vTextureCoord.x );\n   \n\n   gl_FragColor = color.rgba;\n   // gl_FragColor.a = col.a * ( 0.65 - ((vTextureCoord.x)/ (1.0 - vTextureCoord.y) ) ) * 0.5;\n   gl_FragColor.a = col.a * ( 1.0 - smoothstep(-0.1, 0.7, vTextureCoord.x) ) * 0.75;\n   // gl_FragColor.a = col.a;\n\n}"


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/views/shaders/silohuetteColor.glsl
 ** module id = 100
 ** module chunks = 0
 **/